module.exports = __webpack_public_path__ + "static/media/4C.434e31f0.svg";